import {
  Attribute,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { MppBaseDropdown } from '../helpers/base-dropdown';
import { MppLanguageService } from '../../../services/language.service';
import { COMMON_ERRORS_TOKEN } from '../form-controls.constants';
import { TCommonErrors } from '../types/common-errors';

@Component({
  selector: 'mpp-tag-select',
  templateUrl: './tag-select.component.html',
  styleUrls: ['./tag-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'mpp-tag-select' },
})
export class MppTagSelectComponent extends MppBaseDropdown {
  @Input() public readonly readonly: boolean = false;
  @Input() public readonly placeholderText: string = '';
  @Input() public readonly notFoundText: string = '';
  @Input() public items: any[] = [];

  public isOpen = false;

  public constructor(
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef<HTMLElement>,
    viewContainerRef: ViewContainerRef,
    languageService: MppLanguageService,
    @Inject(COMMON_ERRORS_TOKEN) COMMON_ERRORS: TCommonErrors,
    @Attribute('bindValue') public readonly bindValue: string,
    @Attribute('bindLabel') public readonly bindLabel: string
  ) {
    super(changeDetectorRef, elementRef, viewContainerRef, languageService, COMMON_ERRORS);

    this.bindLabel ||= this.DEFAULT_BIND_LABEL;
  }

  public toggleSearch(): void {
    this.isOpen = true;
  }
}
